import { property, State } from '@common/lit/store/index.js';
import type { Purpose } from '@common/types/model.d.js';

export class ConsentStore extends State {
  [key: string | symbol]: unknown;

  // the initial consents
  @property({ value: [] }) initialConsents!: Purpose[];

  // the consent state
  @property({ value: [] }) actualConsents!: Purpose[];

  findPurposeById(purposeId : string) {
    return this.actualConsents.find((purpose) => purpose.purposeId === purposeId);
  }
}

export const store = new ConsentStore();
